module.exports = __webpack_public_path__ + "static/media/Pregnant.d1ee4364.svg";